import { computed } from "vue";
import { useCampaignRootBuiltComponent } from "./useCampaignRootBuiltComponent";
export const useCampaignVariantsBuiltComponentVariable = (campaignId) => {
    const { campaignRootBuiltComponent } = useCampaignRootBuiltComponent(campaignId);
    const variantsVariable = computed(() => {
        var _a;
        return (_a = campaignRootBuiltComponent.value) === null || _a === void 0 ? void 0 : _a.findVariable("variants");
    });
    return {
        variantsVariable,
    };
};
